/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import noimage from '../../../assets/images/no.png'
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { storage } from '../../../helpers/Firebase';
import { GET, PUT } from '../../../helpers/httphelper';
import { toast as superToast } from 'bulma-toast';
import moment from 'moment';
function UpdateChanneling(props) {
    const [date, setdate] = useState('')
    const [time, settime] = useState('')
    const [doctorName, setDoctorName] = useState('')
    const [visitCity, setVisitCity] = useState('')
    const [reason, setReason] = useState('')
    const [feedback, setFeedback] = useState('')
    const [FileUrl, setFileUrl] = useState('')
    const [Progress, setProgress] = useState(0)
    const navigate = useNavigate()
    const params = useParams()
    const cid = params.id
    useEffect(() => {
        getdata()
    }, [])

    const getdata = () => {
        GET(`api/channeling/get/${cid}`).then(data => {
            setdate(moment(data?.date).format("YYYY-MM-DD"))
            settime(data.time)
            setDoctorName(data.doctorName)
            setVisitCity(data.visitCity)
            setReason(data.reason)
            setFeedback(data.feedback)
            setFileUrl(data.pimage)
        }).catch(err => {
            console.log(err)
        })
    }

    const uploadImage = (e) => {
        e.preventDefault()
        const file = e.target.files[0]
        if (!file) {
            return
        }
        const storageRef = ref(storage, `/channelings/${file.name}`); //get file reference
        const uploadTask = uploadBytesResumable(storageRef, file); //upload file

        uploadTask.on("state_changed", (snapshot) => { //listen for state changes
            const prog = Math.round( //get progress percentage
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100 //calculate progress percentage
            ); //end get progress percentage
            setProgress(prog); //set progress
        }, (err) => {
            console.log(err);
        }, () => {
            getDownloadURL(uploadTask.snapshot.ref).then((url) => {
                setFileUrl(url);

                console.log(url);
            })
        })

    }

    const sendData = (e) => {
        e.preventDefault()
        const ob = {
            date,
            time,
            doctorName,
            visitCity,
            reason,
            feedback,
            pimage: FileUrl
        }
        PUT(`api/channeling/update/${cid}`, ob).then(data => {
            console.log(data)
            superToast({
                message: "Updated successfully",
                type: 'is-success',
                dismissible: true,
                position: "top-center",
                animate: { in: 'fadeIn', out: 'fadeOut' },
            })
            navigate(`/viewchanneling/${cid}`)


        }).catch(err => {
            console.log(err)
        })
    }

    return (
        <div className='container'>
            <div className='columns'>
                <div className='column is-6 mt-6'>
                    <div className='columns is-justify-content-center'>
                        <div className='column mt-5 is-8'>
                            <img src={FileUrl === '' ? noimage : FileUrl} className="imgs" alt='' />
                        </div>
                    </div>


                </div>
                <div className="column is-6 mt-2">
                    <form onSubmit={sendData}>
                        <h1 className='title is-2 has-text-centered'>Update Channeling</h1>
                        <div className='columns is-justify-content-center is-mobile  mb-0'>
                            <div className='column is-5 '>
                                <div className="field">
                                    <label className="label">Channeling Date</label>
                                    <div className="control">
                                        <input required className="input is-info" value={date} onChange={(e) => { setdate(e.target.value) }} type="date" />
                                    </div>
                                </div>
                            </div>

                            <div className='column is-5'>
                                <div className="field">
                                    <label className="label">Channeling Time</label>
                                    <div className="control">
                                        <input required className="input is-info" value={time} onChange={(e) => { settime(e.target.value) }} type="time" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='columns is-justify-content-center is-mobile mb-0'>
                            <div className='column is-5'>
                                <div className="field">
                                    <label className="label">Doctor Name</label>
                                    <div className="control">
                                        <input required className="input is-info" value={doctorName} onChange={(e) => { setDoctorName(e.target.value) }} type="text" placeholder='Doctor Name' />
                                    </div>
                                </div>
                            </div>



                            <div className='column is-5'>
                                <div className="field">
                                    <label className="label">Visiting City</label>
                                    <div className="control">
                                        <input required className="input is-info" value={visitCity} onChange={(e) => { setVisitCity(e.target.value) }} type="text" placeholder='Visiting City' />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='columns is-justify-content-center is-mobile mb-0'>
                            <div className='column is-10'>
                                <div className="field">
                                    <label className="label">Reason</label>
                                    <div className="control">
                                        <input required className="input is-info" value={reason} onChange={(e) => { setReason(e.target.value) }} type="text" placeholder='Reason' />
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className='columns is-justify-content-center is-mobile mb-0'>
                            <div className='column is-10'>
                                <div className="field">
                                    <label className="label">Prescription Slip</label>
                                    <div className="control">
                                        <input onChange={(e) => { uploadImage(e) }} className="input is-info" type="file" placeholder='Reason' />
                                    </div>
                                </div>
                                <div className="progressText">
                                    <progress style={{ height: '4px' }} className="progress is-success" value={Progress} max="100">{Progress}</progress>
                                </div>
                            </div>
                        </div>

                        <div className='columns is-justify-content-center is-mobile mb-0'>
                            <div className='column is-10'>
                                <div className="field">
                                    <label className="label">Doctor Feedback</label>
                                    <div className="control">
                                        <input className="input is-info" value={feedback} onChange={(e) => { setFeedback(e.target.value) }} type="input" placeholder='Feedback' />
                                    </div>
                                </div>
                            </div>
                        </div>




                        <h1 className='has-text-centered'><input type='submit' value='Update' className='button is-primary' /></h1>
                    </form>
                </div>
            </div>
        </div >
    );
}

export default UpdateChanneling;